/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { deepClone } from '../utils/identity.js';
const keyCodeRegistry = new Map([
    ['arrow-left', 'ArrowLeft'],
    ['arrow-right', 'ArrowRight'],
    ['arrow-up', 'ArrowUp'],
    ['arrow-down', 'ArrowDown'],
    ['tab', 'Tab'],
    ['enter', 'Enter'],
    ['escape', 'Escape'],
    ['space', ' '],
    ['home', 'Home'],
    ['end', 'End'],
]);
/**
 * KeyCodes is a static class that gives users the ability to lookup and even store
 * keycodes for their applications.
 *
 * @privateRemarks
 *
 * The key codes dictionary/hashmap is private to this module. There is no way to access it directly
 * outside of the module.
 *
 */
export class KeyCodeService {
    /**
     * keycodes() returns a clone of the key codes dictionary/hashmap, not the actual registry.
     * Performing actions on the return value of the keycodes getter will not be reflected in the
     * actual keycodes dictionary!
     */
    static get keycodes() {
        return deepClone(keyCodeRegistry);
    }
    static add(keycode, code) {
        keyCodeRegistry.set(keycode, code);
    }
    static has(keycode) {
        return keyCodeRegistry.has(keycode);
    }
    static getCode(keycode, keyCodeRegistry = this.keycodes) {
        return getKeycodeFromRegistry(keycode, keyCodeRegistry);
    }
}
export function getKeycodeFromRegistry(codeToLookup, registry) {
    return registry.get(codeToLookup) || '';
}
